import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../data.service';

@Component({
  selector: 'app-loading-window',
  templateUrl: './loading-window.component.html',
  styleUrls: ['./loading-window.component.scss']
})
export class LoadingWindowComponent implements OnInit {

  subscription: Subscription;
  loadables: {
    championData: false
  };

  constructor(
    private dataService: DataService,
  ) {
    this.subscription = this.dataService.observeChampionData().subscribe(ready => {
      if (ready)
        this.loadables['championData'] = ready;
    })
  }

  ngOnInit() {
  }

}
